import { IFoodException } from 'types/foodLogistics/foodException.interface'
import { IFoodHistoryDay } from 'types/foodLogistics/foodHistory.interface'
import { IFoodKitchen } from 'types/foodLogistics/foodKitchen.interface'
import { IFoodMealRequest } from 'types/foodLogistics/foodMealRequest.interface'
import { IFoodPerson } from 'types/foodLogistics/foodPerson.interface'
import { IFoodProfile } from 'types/foodLogistics/foodProfile.interface'
import { IMealWindow } from 'types/foodLogistics/mealWindow.interface'

export const dietaryPreferences = [
  { label: 'Local', value: 1 },
  { label: 'Traditional', value: 2 },
  { label: 'Vegetarian', value: 3 },
  { label: 'Kosher', value: 4 },
  { label: 'Halal', value: 5 },
]

export const addFoodItemModalInvalidFields = ['name', 'ingredient', 'category', 'amount', 'price']

export const FOOD_DIETARY_TAGS = ['Regular', 'Vegetarian', 'Halal', 'Gluten-Free', 'Nut Allergy']

export const FOOD_PROVISIONING_MODES = ['Mess Hall', 'Packout', 'Opt-Out', '—']

export const FOOD_STATUS_COLORS: Record<string, string> = {
  Ordered: '#A78BFA',
  Planned: '#60A5FA',
  Served: '#24D07B',
  Finalized: '#24D07B',
  Cancelled: '#8A8A8A',
  Critical: '#E74C3C',
  High: '#ff9900',
  Medium: '#A78BFA',
  Low: '#60A5FA',
  Open: '#24D07B',
  Pending: '#ff9900',
  Approved: '#24D07B',
  Rejected: '#E74C3C',
  'Auto-Routed': '#ff9900',
  Guest: '#A78BFA',
  Emergency: '#E74C3C',
  Resolved: '#8A8A8A',
  'Not Started': '#8A8A8A',
  Awaiting: '#ff9900',
  'In Progress': '#60A5FA',
}

export const foodMealWindowsMock: IMealWindow[] = [
  {
    id: 1,
    name: 'Breakfast',
    time: '06:30–08:00',
    cutoff: '20:30 (prev. day)',
    planned: 145,
    ordered: 145,
    status: 'Ordered',
    locked: true,
    menus: { 1: 'Hausa koko, bread & eggs, fruit', 2: 'Hausa koko, omelette (Halal line), fruit' },
  },

  {
    id: 2,
    name: 'Lunch',
    time: '12:00–13:30',
    cutoff: '09:30',
    planned: 178,
    ordered: 178,
    status: 'Ordered',
    locked: true,
    menus: { 1: 'Jollof rice & grilled chicken, salad', 2: 'Jollof rice & beef (Halal), salad' },
  },

  {
    id: 3,
    name: 'Dinner',
    time: '18:00–19:30',
    cutoff: '15:30',
    planned: 162,
    ordered: 0,
    status: 'Planned',
    locked: false,
    menus: { 1: 'Banku & tilapia, vegetable stew', 2: 'Banku & tilapia (Halal), vegetable stew' },
  },
  {
    id: 4,
    name: 'Night Meal',
    time: '00:30–01:30',
    cutoff: '21:00',
    planned: 38,
    ordered: 0,
    status: 'Planned',
    locked: false,
    menus: { 1: 'Packed: rice, stew, fruit', 2: '—' },
  },
]

export const foodKitchenOrderedMock: { [windowId: number]: { [kitchenId: number]: number } } = {
  1: { 1: 98, 2: 47 },
  2: { 1: 120, 2: 58 },
  3: { 1: 108, 2: 54 },
  4: { 1: 38, 2: 0 },
}

export const foodKitchensMock: IFoodKitchen[] = [
  {
    id: 1,
    name: 'Main Kitchen',
    caps: ['Regular', 'Vegetarian'],
    packout: true,
    softCap: 120,
    standbyEnabled: true,
    operator: 'Contractor',
    standby: [
      { tags: ['Regular'], qty: 8, min: 5 },
      { tags: ['Vegetarian'], qty: 3, min: 3 },
    ],
  },
  {
    id: 2,
    name: 'North Kitchen',
    caps: ['Regular', 'Vegetarian', 'Halal'],
    packout: true,
    softCap: 80,
    standbyEnabled: true,
    operator: 'Internal',
    standby: [
      { tags: ['Regular'], qty: 6, min: 4 },
      { tags: ['Halal'], qty: 4, min: 4 },
    ],
  },
]

export const foodPeopleMock: IFoodPerson[] = [
  {
    id: 1,
    name: 'Ahmed Hassan',
    dept: 'Drilling',
    mode: 'Mess Hall',
    source: 'Entitled',
    kitchenId: 1,
    tags: ['Halal', 'Nut Allergy'],
    status: { 1: 'Ordered', 2: 'Ordered', 3: 'Planned', 4: null },
    flag: 'critical',
    chain: ['Created 19/2 (PLANNED, cfg-3)', 'Ordered — breakfast cut-off run'],
  },
  {
    id: 2,
    name: 'John Smith',
    dept: 'Guest — Client',
    mode: 'Mess Hall',
    source: 'Ad-Hoc',
    kitchenId: 2,
    tags: ['Vegetarian'],
    status: { 1: 'Ordered', 2: null, 3: null, 4: null },
    chain: ['Created from REQ-003', 'Ordered — cut-off run'],
  },
  {
    id: 3,
    name: 'Emmanuel Mensah',
    dept: 'Operations',
    mode: 'Packout',
    source: 'Entitled',
    kitchenId: 1,
    tags: ['Regular'],
    status: { 1: 'Served', 2: 'Ordered', 3: 'Planned', 4: null },
    chain: ['Created 19/2', 'Ordered', 'Served (Main confirmation)'],
  },
  {
    id: 4,
    name: 'Sarah Johnson',
    dept: 'Maintenance',
    mode: 'Mess Hall',
    source: 'Standby',
    kitchenId: 2,
    tags: ['Regular'],
    status: { 1: 'Ordered', 2: 'Ordered', 3: 'Planned', 4: null },
    chain: ['Standby-assigned post cut-off'],
  },
  {
    id: 5,
    name: 'Filip Gonzales',
    dept: 'Operations',
    mode: 'Mess Hall',
    source: 'Entitled',
    kitchenId: 1,
    tags: ['Vegetarian'],
    status: { 1: 'Served', 2: 'Ordered', 3: 'Planned', 4: null },
    chain: ['Created 19/2', 'Ordered', 'Served (Main confirmation)'],
  },
  {
    id: 6,
    name: 'Kwame Asante',
    dept: 'Night Shift — Plant',
    mode: 'Packout',
    source: 'Entitled',
    kitchenId: 1,
    tags: ['Regular'],
    status: { 1: null, 2: null, 3: null, 4: 'Planned' },
    chain: ['Created 20/2 (Night Meal)'],
  },
]

export const foodExceptionsMock: IFoodException[] = [
  {
    id: 1,
    sev: 'Critical',
    type: 'Dietary Mismatch',
    meal: 'Breakfast',
    kitchen: 'Main Kitchen',
    person: 'Ahmed Hassan',
    root: 'Person requires {Halal, Nut Allergy}; Main Kitchen capabilities {Regular, Vegetarian}',
    status: 'Open',
    prov: 'RULE',
    rec: 'Reassign to North Kitchen (covers Halal; nut-safe line confirmed) or assign diet-compatible standby at North.',
    actions: [
      {
        k: 'REASSIGN',
        label: 'Reassign to North Kitchen',
        detail:
          'Diet check: {Halal, Nut Allergy} ⊆ North capabilities ✓ · superseding record created',
      },
      {
        k: 'STANDBY',
        label: 'Assign diet-safe standby (North · Halal ×4)',
        detail: 'Subset rule ✓ · decrements North Halal stock',
      },
      {
        k: 'CANCEL',
        label: 'Cancel meal intent',
        detail: 'Post cut-off: ordered count unchanged, logged as expected waste',
      },
    ],
  },
  {
    id: 2,
    sev: 'High',
    type: 'Missing Kitchen Confirmation',
    meal: 'Breakfast',
    kitchen: 'North Kitchen',
    person: '—',
    root: 'No served-count submission · device queue: 1 unsynced (CONNECTIVITY)',
    status: 'Open',
    prov: 'RULE',
    rec: 'Wait for sync, or enter confirmation on behalf of North Kitchen (audited).',
    actions: [
      {
        k: 'CONFIRM',
        label: 'Enter confirmation on behalf (audited)',
        detail: 'Opens per-kitchen confirmation for North — Breakfast',
      },
    ],
  },
  {
    id: 3,
    sev: 'Medium',
    type: 'Profile Conflict',
    meal: 'Lunch',
    kitchen: '—',
    person: 'David Chen',
    root: 'Profile expects 3 meals; site policy max = 2. Policy applied; profile flagged.',
    status: 'Open',
    prov: 'RULE',
    rec: 'Correct the employee food profile (applies from next intent generation).',
    actions: [
      {
        k: 'PROFILE',
        label: 'Correct profile (effective next generation)',
        detail: 'Opens profile editor',
      },
    ],
  },
  {
    id: 4,
    sev: 'Low',
    type: 'Unresolved Override Note',
    meal: 'Lunch',
    kitchen: 'Main Kitchen',
    person: 'Sarah Johnson',
    root: 'Override applied 19/2 without follow-up note.',
    status: 'Open',
    prov: 'RULE',
    rec: 'Informational — comment closure permitted for Low severity.',
    actions: [],
  },
]

export const foodMealRequestsMock: IFoodMealRequest[] = [
  {
    id: 'REQ-001',
    type: 'Guest',
    meal: 'Breakfast',
    day: '20/2/2028',
    qty: 2,
    lines: [{ tags: ['Regular'], qty: 2 }],
    routing: 'Standby',
    status: 'Auto-Routed',
    by: 'Site Manager',
    reason: 'Two visiting geologists.',
  },
  {
    id: 'REQ-002',
    type: 'Emergency',
    meal: 'Breakfast',
    day: '20/2/2028',
    qty: 5,
    lines: [
      { tags: ['Regular'], qty: 3 },
      { tags: ['Halal'], qty: 2 },
    ],
    routing: '—',
    status: 'Pending',
    by: 'Supervisor A',
    reason: 'Unexpected contractor team arrived for urgent repairs.',
  },
  {
    id: 'REQ-003',
    type: 'Guest',
    meal: 'Breakfast',
    day: '20/2/2028',
    qty: 3,
    lines: [{ tags: ['Vegetarian'], qty: 3 }],
    routing: 'Standard',
    status: 'Approved',
    by: 'Site Manager',
    reason: 'Client visit.',
  },
]

export const foodProfilesMock: IFoodProfile[] = [
  {
    id: 1,
    name: 'John Smith',
    dept: 'Operations',
    role: 'Site Operator',
    tags: ['Regular'],
    defaults: { Breakfast: 'Mess Hall', Lunch: 'Packout', Dinner: 'Mess Hall', 'Night Meal': '—' },
    stickyKitchen: 'None — Auto Assign',
  },
  {
    id: 2,
    name: 'Emmanuel Mensah',
    dept: 'Operations',
    role: 'Operator',
    tags: ['Regular'],
    defaults: { Breakfast: 'Mess Hall', Lunch: 'Packout', Dinner: 'Mess Hall', 'Night Meal': '—' },
    stickyKitchen: 'None — Auto Assign',
  },
  {
    id: 3,
    name: 'Sarah Johnson',
    dept: 'Maintenance',
    role: 'Technician',
    tags: ['Regular'],
    defaults: {
      Breakfast: 'Mess Hall',
      Lunch: 'Mess Hall',
      Dinner: 'Mess Hall',
      'Night Meal': '—',
    },
    stickyKitchen: 'North Kitchen',
  },
]

export const foodHistoryMock: IFoodHistoryDay[] = [
  {
    id: '19-2-2028',
    date: '19/2/2028',
    status: 'Finalized',
    breakfast: '42/42/40',
    lunch: '75/75/75',
    dinner: '58/58/56',
    nightMeal: '12/12/12',
    exceptions: 3,
    standbyUsed: 2,
    reversals: 0,
  },
  {
    id: '18-2-2028',
    date: '18/2/2028',
    status: 'Finalized',
    breakfast: '38/38/36',
    lunch: '72/72/71',
    dinner: '55/55/55',
    nightMeal: '10/10/9',
    exceptions: 2,
    standbyUsed: 4,
    reversals: 1,
  },
  {
    id: '20-2-2028',
    date: '20/2/2028',
    status: 'In Progress',
    breakfast: '145/145/96',
    lunch: '178/178/—',
    dinner: '162/—/—',
    nightMeal: '38/—/—',
    exceptions: 4,
    standbyUsed: 3,
    reversals: 0,
  },
]

export const foodInitialConfirmations: {
  [key: string]: { served: number; standbyUsed: number; onBehalf: boolean }
} = {
  '1-1': { served: 96, standbyUsed: 2, onBehalf: false },
}

export const FOOD_UNKNOWN_POLICIES = [
  {
    key: 'NO_MEAL',
    label: 'No Meal',
    desc: 'No hot intent; arrivals served from standby (site default)',
    on: true,
  },
  {
    key: 'PLAN_MEAL',
    label: 'Plan Meal',
    desc: 'Generate hot intent — protects service level, risks waste',
    on: false,
  },
  {
    key: 'STANDBY_RESERVE',
    label: 'Standby Reserve',
    desc: 'Reserve standby equal to UNKNOWN count, capped by stock',
    on: false,
  },
]

export const FOOD_MEAL_PRIORITY = ['Lunch', 'Dinner', 'Breakfast', 'Night Meal']
